(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[330],{

/***/ 881:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...slug]",
      function () {
        return __webpack_require__(8556);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./lib/baseUrl.ts
var baseUrl = __webpack_require__(9836);
// EXTERNAL MODULE: ./lib/classNames.ts
var classNames = __webpack_require__(9413);
// EXTERNAL MODULE: ./components/ComponentSwitch.tsx + 11 modules
var ComponentSwitch = __webpack_require__(1079);
// EXTERNAL MODULE: ./components/PostCard.tsx
var PostCard = __webpack_require__(5745);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/BlurImage.tsx
var BlurImage = __webpack_require__(1166);
;// CONCATENATED MODULE: ./components/PostListing.tsx



var PostListing = function(param) {
    var post = param.post;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/blog/" + post.seo.slug,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "bg-white cursor-pointer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto max-w-7xl sm:px-2 lg:px-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-w-2xl px-4 mx-auto lg:max-w-none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "py-5 space-y-16",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col lg:grid lg:grid-cols-12 lg:gap-x-8 lg:items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex-auto lg:col-span-5 xl:col-span-5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "overflow-hidden bg-gray-100 rounded-lg aspect-w-5 aspect-h-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlurImage/* default */.Z, {
                                            src: ((ref = post.image) === null || ref === void 0 ? void 0 : ref.url) || "/logo-with-background.png",
                                            alt: post.imageAlt || post.title,
                                            className: "object-cover object-center rounded-xl",
                                            fill: true,
                                            sizes: "(max-width: 768px) 95vw, (max-width: 1200px) 33vw, 33vw"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-6 lg:mt-0 lg:col-span-7 xl:col-span-7",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-lg font-medium text-gray-900",
                                            children: post.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mt-2 text-sm text-gray-500",
                                            children: post.description
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var components_PostListing = (PostListing);

// EXTERNAL MODULE: ./components/sections/SplitBrandContactForm.tsx
var SplitBrandContactForm = __webpack_require__(8725);
;// CONCATENATED MODULE: ./components/Category.tsx









var Category = function(param) {
    var category = param.category, posts = param.posts, treatments = param.treatments;
    var longestCategoryTreatment = treatments.reduce(function(a, b) {
        return a.categories.length > b.categories.length ? a : b;
    }, treatments[0]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: category.seo.title || category.name || "",
                description: category.seo.description || category.description || "",
                noindex: category.seo.noIndex,
                openGraph: {
                    title: category.seo.title || category.name || "",
                    description: category.seo.description || category.description || ""
                },
                canonical: category.rootCategory ? [
                    baseUrl/* default */.Z,
                    category.seo.slug
                ].join("/") : baseUrl/* default */.Z + "/" + longestCategoryTreatment.categories.map(function(c) {
                    return c.seo.slug;
                }).join("/")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative py-12 overflow-hidden ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative px-4 sm:px-6 lg:px-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mx-auto text-lg max-w-prose",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "block mt-2 text-3xl font-extrabold leading-8 tracking-tight text-center text-gray-900 sm:text-4xl",
                                        children: category.name
                                    }),
                                    category.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-8 text-xl leading-8 text-gray-500",
                                        children: category.description
                                    })
                                ]
                            })
                        })
                    }),
                    treatments.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative px-4 pt-4 pb-20 bg-gray-50 sm:px-6 lg:pt-14 lg:pb-28 lg:px-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative mx-auto max-w-7xl",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,classNames/* default */.Z)(treatments.length < 3 ? "lg:grid-cols-2" : "lg:grid-cols-3", "grid max-w-lg gap-5 mx-auto mt-12 lg:max-w-none"),
                                children: treatments.map(function(_param) /*#__PURE__*/ {
                                    var __typename = _param.__typename, treatment = (0,_object_without_properties/* default */.Z)(_param, [
                                        "__typename"
                                    ]);
                                    return (0,jsx_runtime.jsx)(PostCard/* default */.Z, {
                                        post: treatment,
                                        treatmentCard: true
                                    }, treatment.id);
                                })
                            })
                        })
                    })
                ]
            }),
            category.components && /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentSwitch/* default */.Z, {
                components: category.components
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "px-4 mx-auto max-w-7xl sm:px-6 lg:px-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative z-10 flex items-baseline justify-between pt-12 pb-6 border-b border-gray-200",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                className: "mx-auto text-4xl font-extrabold tracking-tight text-center text-gray-900",
                                children: [
                                    category.name,
                                    " Articles"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            "aria-labelledby": "posts",
                            className: "pt-6 pb-24",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col",
                                children: posts.map(function(post) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PostListing, {
                                        post: post
                                    }, post.id);
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SplitBrandContactForm/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var components_Category = (Category);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/GraftCalculator.tsx





var GraftCalculator = function() {
    var ref = (0,react.useState)({
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        51: false,
        6: false,
        7: false,
        8: false,
        9: false,
        10: false
    }), areas = ref[0], setAreas = ref[1];
    var calculateGrafts = function() {
        var graftCounts = {
            1: 650,
            2: 1000,
            3: 1250,
            4: 1400,
            5: 1150,
            6: 1750,
            7: 1400,
            8: 1250,
            9: 1150,
            10: 2250,
            51: 650
        };
        return Object.entries(areas).reduce(function(total, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            if (value && graftCounts[Number(key)]) {
                total += graftCounts[Number(key)];
            }
            return total;
        }, 0);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "my-16 max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8 border border-gray-200",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-4xl font-bold text-center mb-8 text-gray-800",
                children: "Hair Transplant Graft Calculator"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-6 text-center mb-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-xl text-gray-600",
                        children: "Curious about your hair transplant needs? Use our interactive Norwood Scale-based calculator for a quick estimate."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-md text-gray-500 italic",
                        children: "Remember: This is just a starting point. Individual needs may vary."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center flex-wrap gap-8 mb-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative w-[400px] h-[400px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute z-10",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/consultation/head-left-nr.png",
                                useMap: "#head_left",
                                alt: "Head diagram - Left view"
                            })
                        }),
                        Object.entries(areas).map(function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                            return value && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/consultation/head-left-".concat(key.padStart(2, "0"), ".png"),
                                    alt: "Area ".concat(key),
                                    useMap: "#head_left"
                                })
                            }, key);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/consultation/head-left-00.png",
                            useMap: "#head_left",
                            alt: "Head base - Left view"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("map", {
                            name: "head_left",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("area", {
                                    shape: "poly",
                                    alt: "",
                                    coords: "224,52, 228,57, 241,75, 229,77, 220,73, 214,67, 213,66, 209,60, 208,50, 212,41, 224,52",
                                    onClick: function() {
                                        return setAreas(function(prev) {
                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                51: !prev[51]
                                            });
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("area", {
                                    shape: "poly",
                                    alt: "",
                                    coords: "197,202, 201,196, 203,194, 206,190, 216,199, 225,207, 233,213, 227,229, 212,211, 197,202",
                                    onClick: function() {
                                        return setAreas(function(prev) {
                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                9: !prev[9]
                                            });
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("area", {
                                    shape: "poly",
                                    alt: "",
                                    coords: "257,130, 257,131, 257,139, 254,154, 234,143, 230,136, 222,118, 234,123, 247,126, 248,126, 256,127, 257,130",
                                    onClick: function() {
                                        return setAreas(function(prev) {
                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                7: !prev[7]
                                            });
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("area", {
                                    shape: "poly",
                                    alt: "",
                                    coords: "239,197, 236,206, 235,208, 227,202, 219,195, 209,187, 214,180, 215,172, 215,162, 215,156, 211,149, 200,141, 200,141, 188,143, 179,150, 174,160, 168,161, 162,162, 162,162, 162,160, 162,159, 160,154, 157,146, 153,140, 149,135, 145,129, 154,115, 162,107, 165,105, 173,101, 181,103, 192,110, 202,118, 209,125, 213,130, 223,140, 237,151, 253,159, 252,162, 246,181, 239,197",
                                    onClick: function() {
                                        return setAreas(function(prev) {
                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                10: !prev[10]
                                            });
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("area", {
                                    shape: "poly",
                                    alt: "",
                                    coords: "59,74, 60,74, 59,73, 70,68, 83,70, 101,65, 114,60, 131,59, 143,58, 156,55, 157,55, 162,56, 166,57, 166,81, 161,84, 159,85, 156,76, 148,72, 136,72, 126,74, 126,74, 115,77, 101,81, 88,84, 75,85, 68,84, 61,79, 56,76, 59,74",
                                    onClick: function() {
                                        return setAreas(function(prev) {
                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                2: !prev[2]
                                            });
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("area", {
                                    shape: "poly",
                                    alt: "",
                                    coords: "83,56, 92,46, 108,36, 127,28, 150,25, 150,26, 158,36, 165,51, 157,50, 155,51, 143,53, 131,54, 122,54, 109,56, 98,60, 87,65, 75,64, 83,56",
                                    onClick: function() {
                                        return setAreas(function(prev) {
                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                3: !prev[3]
                                            });
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("area", {
                                    shape: "poly",
                                    alt: "",
                                    coords: "197,34, 192,58, 187,74, 181,75, 179,76, 172,78, 171,55, 165,37, 157,26, 160,26, 181,29, 197,34",
                                    onClick: function() {
                                        return setAreas(function(prev) {
                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                4: !prev[4]
                                            });
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("area", {
                                    shape: "poly",
                                    alt: "",
                                    coords: "217,111, 212,105, 203,91, 203,90, 216,96, 234,99, 250,95, 255,122, 249,121, 248,121, 237,118, 225,114, 217,111",
                                    onClick: function() {
                                        return setAreas(function(prev) {
                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                6: !prev[6]
                                            });
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("area", {
                                    shape: "poly",
                                    alt: "",
                                    coords: "201,84, 197,78, 192,74, 197,58, 202,36, 207,38, 203,50, 205,61, 209,69, 211,71, 219,78, 232,82, 244,79, 249,90, 233,94, 217,91, 204,85, 201,84",
                                    onClick: function() {
                                        return setAreas(function(prev) {
                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                5: !prev[5]
                                            });
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("area", {
                                    shape: "poly",
                                    alt: "",
                                    coords: "142,123, 143,116, 146,106, 152,98, 157,93, 164,88, 173,83, 181,81, 183,80, 189,79, 193,81, 197,89, 199,93, 207,107, 215,115, 215,115, 219,124, 224,134, 216,125, 213,122, 205,115, 194,106, 184,98, 173,96, 163,100, 158,103, 151,111, 142,123",
                                    onClick: function() {
                                        return setAreas(function(prev) {
                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                8: !prev[8]
                                            });
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("area", {
                                    shape: "poly",
                                    alt: "",
                                    coords: "155,88, 148,94, 147,95, 142,84, 133,77, 147,77, 153,80, 154,88, 155,88",
                                    onClick: function() {
                                        return setAreas(function(prev) {
                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                1: !prev[1]
                                            });
                                        });
                                    }
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "text-center mt-10 text-3xl font-semibold text-blue-600",
                children: [
                    "Estimated grafts needed: ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-4xl",
                        children: calculateGrafts()
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-10 bg-gray-100 p-8 rounded-lg shadow-inner",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-2xl font-semibold mb-4 text-center text-gray-800",
                        children: "Get a Precise Assessment"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-center mb-6 text-lg text-gray-600",
                        children: "For a personalized evaluation, send your scalp photos from multiple angles:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-center space-x-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.welfareabroad.com/#contact-us",
                                className: "bg-blue-600 text-white px-8 py-4 rounded-full hover:bg-blue-700 transition duration-300 text-lg font-semibold shadow-md",
                                children: "Contact Form"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: "https://wa.me/447503753001",
                                className: "bg-green-600 text-white px-8 py-4 rounded-full hover:bg-green-700 transition duration-300 flex items-center text-lg font-semibold shadow-md",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        className: "w-6 h-6 mr-2",
                                        fill: "currentColor",
                                        viewBox: "0 0 24 24",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"
                                        })
                                    }),
                                    "WhatsApp"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_GraftCalculator = (GraftCalculator);

;// CONCATENATED MODULE: ./components/hair-transplant-prices.tsx


var renderRichText = function(content) {
    if (!content || !content.children) return null;
    return content.children.map(function(node, index) {
        if (node.type === "paragraph") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: node.children.map(function(child, childIndex) {
                    if (child.bold) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: child.text
                        }, childIndex);
                    }
                    return child.text;
                })
            }, index);
        }
        return null;
    });
};
var HairTransplantPrices = function(param) {
    var packages = param.packages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid grid-cols-1 lg:grid-cols-2 gap-8",
        children: packages.map(function(pkg, index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                className: "bg-white rounded-lg shadow-md overflow-hidden transition duration-300 hover:shadow-lg border-t-4 border-blue-600",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-gradient-to-r from-blue-600 to-teal-500 p-6 text-white",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-3xl font-bold mb-2",
                                children: pkg.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-lg opacity-90",
                                children: "Comprehensive Care Package"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "p-6",
                        children: pkg.cards.map(function(card, cardIndex) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                className: "mb-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-4xl font-bold text-blue-600 mb-4",
                                        children: renderRichText((ref = card.price) === null || ref === void 0 ? void 0 : ref.raw)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "space-y-3",
                                        children: card.cardItems.map(function(item, itemIndex) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: "flex items-start",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        className: "w-6 h-6 text-green-500 mr-3 mt-1 flex-shrink-0",
                                                        fill: "none",
                                                        stroke: "currentColor",
                                                        viewBox: "0 0 24 24",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            strokeWidth: "2",
                                                            d: "M5 13l4 4L19 7"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-gray-700 text-lg",
                                                        children: item.feature
                                                    })
                                                ]
                                            }, itemIndex);
                                        })
                                    })
                                ]
                            }, cardIndex);
                        })
                    })
                ]
            }, index);
        })
    });
};
/* harmony default export */ var hair_transplant_prices = (HairTransplantPrices);

// EXTERNAL MODULE: ./components/Layout.tsx + 6 modules
var Layout = __webpack_require__(3620);
// EXTERNAL MODULE: ./components/Page.tsx
var Page = __webpack_require__(6000);
;// CONCATENATED MODULE: ./components/Treatment.tsx




var Treatment = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: props.seo.title || props.title || "",
                description: props.seo.description || props.description || "",
                noindex: props.seo.noIndex,
                openGraph: {
                    title: props.seo.title || props.title || "",
                    description: props.seo.description || props.description || ""
                },
                canonical: baseUrl/* default */.Z + "/" + props.categories.map(function(c) {
                    return c.seo.slug;
                }).join("/") + "/" + props.seo.slug
            }),
            props.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative py-12 overflow-hidden bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative px-4 sm:px-6 lg:px-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-auto text-lg max-w-prose",
                        children: [
                            props.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "block mt-2 text-3xl font-extrabold leading-8 tracking-tight text-center text-gray-900 sm:text-4xl",
                                    children: props.title
                                })
                            }),
                            props.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-8 text-xl leading-8 text-gray-500",
                                children: props.description
                            })
                        ]
                    })
                })
            }),
            props.components && /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentSwitch/* default */.Z, {
                components: props.components
            })
        ]
    });
};
/* harmony default export */ var components_Treatment = (Treatment);

;// CONCATENATED MODULE: ./pages/[...slug].tsx













// Add this testimonials array at the top of your file
var testimonials = [
    {
        text: "Extremely friendly and professional from start to finish. I would recommend the welfare abroad team to anyone thinking of having a hair transplant as it is daunting having a procedure in a different country. The care is absolutely first...",
        name: "Ian W.",
        rating: 5,
        date: "2 years ago"
    },
    {
        text: "Just arrived back in the UK after my hair transplant. I was very happy with the whole trip from airport transfers, hotel transfers to and from the hospital and the procedure itself. I would recommend welfare abroad to anyone thinking about getting a transplant, a special thanks to Ulash, Dr Gamze, Richard and the technicians.",
        name: "Matty Lawrenson",
        rating: 5,
        date: "a year ago"
    },
    {
        text: "Very pleased with the whole experience, from airport pick up, the whole team very friendly and professional. Had my reservations going abroad for surgery, without hesitation would recommend. A fraction of the price of UK, modern clinic and fully regulated, thank you again!",
        name: "Mark Sinclair",
        rating: 5,
        date: "a year ago"
    },
    {
        text: "It's not often I write reviews but I feel like this experience is worth giving people an insight to what welfare abroad are about and for anyone wishing to get a hair transplant. The service & communication from the start to sending your...",
        name: "Joshua Ward",
        rating: 5,
        date: "11 months ago"
    }
];
var TestimonialsSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "py-32 bg-gray-50",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container mx-auto px-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-5xl font-bold text-center mb-16 text-gray-800",
                    children: "What Our Clients Say"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid md:grid-cols-2 gap-8",
                    children: testimonials.map(function(testimonial, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "bg-white p-6 rounded-lg shadow-lg",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center mb-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-yellow-400 mr-2",
                                            children: "★".repeat(testimonial.rating)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-gray-600 text-sm",
                                            children: testimonial.date
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-gray-600 mb-4",
                                    children: [
                                        '"',
                                        testimonial.text,
                                        '"'
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "font-bold text-blue-600",
                                    children: testimonial.name
                                })
                            ]
                        }, index);
                    })
                })
            ]
        })
    });
};
var CatchAll = function(_param) {
    var data = _param.data, commonProps = (0,_object_without_properties/* default */.Z)(_param, [
        "data"
    ]);
    var renderSwitch = function(data) {
        if (data.__typename === "HairTransplantPrices") {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                        title: "Hair Transplant Packages | Welfare Abroad",
                        description: "Explore our hair transplant package options in Turkey and UK. Calculate your graft needs and find the perfect solution for you.",
                        canonical: baseUrl/* default */.Z + "/hair-transplant-prices"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative bg-gradient-to-r from-blue-700 to-blue-500 text-white py-24",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "container mx-auto px-4 relative z-10",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "text-4xl md:text-6xl font-extrabold mb-6 leading-tight",
                                        children: "Premium Hair Transplants at Affordable Prices"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-xl md:text-2xl mb-10 font-light",
                                        children: "Experience world-class care in Turkey or the UK with Welfare Abroad"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col sm:flex-row gap-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "#calculator",
                                                className: "bg-green-500 text-white px-8 py-3 rounded-full font-semibold hover:bg-green-600 transition duration-300 shadow-lg text-lg text-center",
                                                children: "Calculate Your Graft Needs"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "#packages",
                                                className: "bg-transparent border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-blue-700 transition duration-300 shadow-lg text-lg text-center",
                                                children: "Our Hair Transplant Packages"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-0 bg-black opacity-40"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/istOrlondon.jpeg",
                                layout: "fill",
                                objectFit: "cover",
                                alt: "Hair Transplant Hero",
                                className: "absolute inset-0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "py-32 bg-white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container mx-auto px-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-5xl font-bold text-center mb-12 text-gray-800",
                                    children: "Transparent Pricing for Your Hair Transplant Journey"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "max-w-3xl mx-auto text-gray-600 space-y-8 text-lg",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "At Welfare Abroad, we believe in offering clear and comprehensive pricing for your hair transplant procedures. We understand that each person's hair restoration journey is unique, and it's crucial to have full visibility into what's included in your treatment package. Whether you're exploring your options for the first time or comparing services, our packages are designed to offer exceptional value, covering all essential care and services to ensure a successful outcome."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Our packages provide a holistic approach to your hair transplant experience. From expert consultation and personalized treatment plans to advanced, state-of-the-art facilities and techniques, we ensure every aspect of your procedure is carefully managed. You'll receive comprehensive post-operative care and follow-up services to support your recovery, all at an affordable price with no hidden fees."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "With our commitment to excellence, you can rest assured that your experience will be seamless, tailored to your individual needs, and focused on delivering the best possible results."
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "packages",
                        className: "py-32 bg-gray-50",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container mx-auto px-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-5xl font-bold text-center mb-16 text-gray-800",
                                    children: "Our Hair Transplant Packages"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(hair_transplant_prices, {
                                    packages: data.hairTransplantPackages
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-16 text-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "#calculator",
                                        className: "bg-green-500 text-white px-8 py-3 rounded-full font-semibold hover:bg-green-600 transition duration-300 shadow-lg text-lg inline-block",
                                        children: "Calculate Your Graft Needs"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "calculator",
                        className: "py-32 bg-white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container mx-auto px-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_GraftCalculator, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialsSection, {})
                ]
            });
        }
        switch(data === null || data === void 0 ? void 0 : data.__typename){
            case "Page":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
                    page: data
                });
            case "Treatment":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Treatment, (0,_object_spread/* default */.Z)({}, data));
            case "Category":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Category, {
                    category: data,
                    posts: data.posts,
                    treatments: data.treatments
                });
            default:
                return;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonProps), {
        children: renderSwitch(data)
    }));
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (CatchAll);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [336,853,555,633,697,620,617,0,774,888,179], function() { return __webpack_exec__(881); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);